import { render, staticRenderFns } from "./unit_indicator_publicaton_tab.vue?vue&type=template&id=41a1e71a"
import script from "./unit_indicator_publicaton_tab.vue?vue&type=script&lang=js"
export * from "./unit_indicator_publicaton_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports